export const sendGdprLevelEvents = (gdprLevel) => {
  setTimeout(() => {
    const event = new CustomEvent("gdpr-level-ready", { detail: gdprLevel });
    window.dispatchEvent(event);
  });
};
